import { OysterBandIndexEnum } from "@oysterhr/schema"
import { Badge, BadgeVariation } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"

export const OBILevelBadge = ({ level }: { level: OysterBandIndexEnum }) => {
  const { t } = useTranslation("salary_insights_tool/result")
  return (
    <Badge size="md" variation={mapOBILevelToColor[level]}>
      {t(`obiLevel.${level}`)}
    </Badge>
  )
}
const mapOBILevelToColor: Record<OysterBandIndexEnum, BadgeVariation> = {
  [OysterBandIndexEnum.High]: "success",
  [OysterBandIndexEnum.Mid]: "warning",
  [OysterBandIndexEnum.Low]: "error",
}
